<template lang="pug">
#cf-turnstile(style="line-height: 0")
  slot
</template>
<script>
export default {
  name: 'CloudflareTurnstile',
  emits: ['rendering', 'rendered', 'verified', 'error'],
  props: {
    siteKey: {type: String, required: true},
    theme: {type: String, default: 'auto'},
    size: {type: String, default: 'normal'},
    autoReset: {type: Boolean, default: false},
    resetTimeout: {type: Number, default: 295 * 1000},
    recaptchaCompat: {type: Boolean, default: false},
    explicitRender: {type: Boolean, default: false},
    appearance: {type: String, default: 'always'},
    language: {type: String, default: 'auto'}
  },
  data() {
    return {
      widgetId: undefined
    }
  },
  beforeMount() {
    if (!window.turnstile) {
      this.initTurnstile()
    }
  },
  mounted() {
    this.$emit('rendering')

    if (!window.turnstile) {
      this.onloadTurnstileCallback()
    } else {
      this.render()
    }
  },
  methods: {
    initTurnstile() {
      const script = document.createElement('script')
      const turnstileSrc = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
      const callback = 'onloadTurnstileCallback'
      const compat = this.recaptchaCompat ? '&compat=recaptcha' : ''
      const render = this.explicitRender ? '&render=explicit' : ''

      script.src = `${turnstileSrc}?onload=${callback}${compat}${render}`
      script.async = true
      script.defer = true

      document.head.appendChild(script)
    },
    reset() {
      if (window.turnstile) {
        window.turnstile.reset(this.widgetId)
      }
    },
    remove() {
      if (this.widgetId) {
        window.turnstile.remove(this.widgetId)
        this.widgetId = null
      }
    },
    execute() {
      // if (this.widgetId) {
      //   window.turnstile.execute(this.widgetId)
      //   this.widgetId = null
      // }
    },
    render() {
      this.widgetId = window.turnstile.render('#cf-turnstile', {
        sitekey: this.siteKey,
        theme: this.theme,
        size: this.size,
        appearance: this.appearance,
        language: this.language,
        callback: token => {
          this.$emit('verified', token)
        },
        'expired-callback': () => {
          this.reset()
        },
        'error-callback': error => {
          console.error(`Error callback: ${error}`)

          this.$emit('error', error)
        }
      })

      this.$emit('rendered')
    },
    onloadTurnstileCallback() {
      window.onloadTurnstileCallback = () => {
        this.render()
      }
    }
  },
  beforeUnmount() {
    this.remove()
  }
}
</script>
